import { jsxs as M, Fragment as P, jsx as R } from "react/jsx-runtime";
import { BadRequest as j } from "@systemeio/util";
import { useStore as O, useOfferStore as Y, useXenditStore as $ } from "../../store/index.mjs";
import J from "../../ui-kit/theme-button.mjs";
import { getCardHolderFirstLastName as z } from "../payment-inputs/get-card-holder-first-last-name.mjs";
import { xenditBuyOffer as G } from "./api/index.mjs";
import { useLoadXenditScript as K } from "./hooks/use-load-xendit-script.mjs";
import { useXenditThreeDs as Q } from "./hooks/use-xendit-three-ds.mjs";
import { XenditCreditCardStatusEnum as n } from "./types/index.mjs";
import { useTranslation as U, ContactSlugEnum as p, toast as a } from "@systemeio/ui";
import { twJoin as V } from "tailwind-merge";
function ie({
  isFetching: _,
  buttonTitle: h,
  buttonDisabled: y,
  setIsFetching: r,
  preSubmit: l,
  handleBadRequest: w,
  hasErrors: b
}) {
  const { t: u } = U(), { locale: x } = O(), { currency: c, finalAmount: i } = Y(), { cardNumber: N, cardHolderName: X, cvc: v, expiryMonth: S, expiryYear: D, formInvalid: m } = $(), { isScriptLoading: k } = K(), { openLinkInIframe: f, threeDsModal: B, closeThreeDsModal: E } = Q(
    () => r(!1)
  ), H = async (o, e) => {
    if (o) {
      a.error(o.message), r(!1);
      return;
    } else if (e.status === n.in_review)
      f(e.payer_authentication_url);
    else if (e.status === n.verified) {
      setTimeout(() => {
        E();
      }, 1e3);
      try {
        const t = l();
        if (!t) return;
        const { redirect: s } = await G(
          {
            ...t,
            options: { token: e.credit_card_token_id }
          },
          x
        );
        if (s) {
          window.location.assign(s);
          return;
        } else
          a.error(u("public_pages_purchase.error"));
      } catch (t) {
        if (t instanceof j)
          w(t);
        else
          throw t;
      } finally {
        r(!1);
      }
    }
  }, L = async (o, e) => {
    if (o) {
      a.error(o.message), r(!1);
      return;
    }
    if (!window.Xendit || !i) {
      a.error(u("public_pages_purchase.error")), r(!1);
      return;
    }
    e.status === n.verified ? window.Xendit.card.createAuthentication(
      {
        amount: i,
        token_id: e.id
      },
      H
    ) : e.status === n.in_review ? f(e.payer_authentication_url) : e.status === n.failed && (a.error(u("public_pages_purchase.error")), r(!1));
  }, T = async (o) => {
    o.preventDefault(), r(!0);
    try {
      const e = l();
      if (!e || !i || !c) return;
      if (window.Xendit) {
        const t = `20${D}`, { firstName: s = "", lastName: g = "" } = z(X), q = e.customer.fields[p.Email] ?? "", d = e.customer.fields[p.PhoneNumber] ?? "", A = d ? `+${d}` : "";
        window.Xendit.card.createToken(
          {
            amount: i,
            card_number: N,
            card_exp_month: S,
            card_exp_year: t,
            card_cvn: v,
            card_holder_first_name: s,
            card_holder_last_name: g,
            card_holder_email: q,
            card_holder_phone_number: A,
            is_multiple_use: !0,
            should_authenticate: !0,
            currency: c
          },
          L
        );
      }
    } catch (e) {
      throw e;
    } finally {
      r(!1);
    }
  };
  return /* @__PURE__ */ M(P, { children: [
    B,
    /* @__PURE__ */ R(
      J,
      {
        className: V(
          "main-transition-colors",
          (b || m) && "bg-danger focus:bg-danger"
        ),
        onClick: T,
        isFetching: _,
        disabled: k || m || y,
        type: "submit",
        children: h
      }
    )
  ] });
}
export {
  ie as XenditPaymentButton
};
